var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolyLineIconLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 259,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u9577\\u65B9\\u5F62 498",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 251h46v8H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.5 251.5h45v7H.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u9577\\u65B9\\u5F62 499",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M38 259V11h8v248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M38.5 258.5v-247h7v247z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u591A\\u89D2\\u5F62 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5 28.793V1.207L87.293 15 73.5 28.793z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.586 15L74 2.414v25.172L86.586 15M88 15L73 30V0l15 15z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u9577\\u65B9\\u5F62 500",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M38 11h35v8H38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M38.5 11.5h34v7h-34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyLineIconLarge);
export default __webpack_public_path__ + "static/media/polyLineIconLarge.9c55b01cb2cba21d.svg";
export { ForwardRef as ReactComponent };